// extracted by mini-css-extract-plugin
export default {"main-container":"StartPage_main-container__QPcyD","notesgroup":"StartPage_notesgroup__-aRHF","notesdisplay":"StartPage_notesdisplay__AaK91"};